import AttachmentAdd from './new';
import AttachmentEdit from './edit'
import { getEnvVariable } from '../../../modules/environmentalList';
const AttachmentGrid = {
    "title": "Attachments",
    "type": "grid",
    "key": "AttachmentGrid",
    "gridkey": 'AttachmentGrid',
    "name": "AttachmentGrid",
    "hasreport": true,
    values: {
        addOpen: false,
        editOpen: false,
        editInfo: null,
        load: false,
        allgriddata: null,
        navigateItem: null,
        navigation: null,
        reportOpen: false,
        loadreportfilter: null,
        ReportJsonQueryStr: null,
    },
    sharedValues: ['addOpen', 'editOpen', 'editInfo', 'allgriddata', 'navigateItem', 'navigation', 'loadreportfilter', 'ReportJsonQueryStr', 'reportOpen'],
    aliases: {
        addOpen: 'addOpen',
        editOpen: 'editOpen',
        editInfo: 'editInfo',
        allgriddata: 'allgriddata',
        navigateItem: 'navigateItem',
        navigation: 'navigation',
        reportOpen: 'reportOpen',
        loadreportfilter: 'loadreportfilter',
        ReportJsonQueryStr: 'ReportJsonQueryStr'
    },
    headerProps: {
        title: "Attachments",
        components: [
            // {
            //     type: 'breadcrumbs',
            //     items: [
            //         { "link": "Attachments", "materialicon": "beenhereoutlined", className: 'breadcrumb-item ', class: '' }

            //     ],
            // }
        ],
        actions: [
            // {
            //     type: 'fab',
            //     icon: 'back',
            //     name: 'back',
            //     color: 'primary',
            //     title: 'Back',
            //     menucolor: '#924fe3',
            //     hideon: 'back',
            //     hidevalue: false

            // },
            {
                type: 'fab',
                icon: 'clear',
                name: 'clear',
                color: 'primary',
                title: 'Clear Filters',
                menucolor: '#22a9b3',
                hideon: 'clear',
                hidevalue: false
            },

            {
                type: 'menu',
                icon: 'excel',
                name: 'excel',
                color: 'primary',
                title: 'Export to Excel',
                menucolor: '#c90685',
                hideon: 'excel',
                hidevalue: false,
                items: [{
                    name: 'Export Current Page',
                    action: 'filtercurrent'
                },
                {
                    name: 'Export All Pages',
                    action: 'filterall'
                }
                ]
            },
            {
                type: 'fab',
                icon: 'add',
                name: 'add',
                color: 'primary',
                hideon: 'addButton',
                hidevalue: true,
                title: 'Add Attachment',
                menucolor: '#36088a'
            },
        ]
    },
    "columns": [
        {
            "title": "File Name",
            "field": "FileName",
            "show": true,
            "width": 20,
        },
        {
            "title": "Notes",
            "field": "Notes",
            "show": true,
            "width": 100,
            filterable: true
        },
        // {
        //     "title": "Total Files Uploaded",
        //     "field": "filesCount",
        //     "show": true,
        //     "width": 300,
        //     filterable: true
        // },

        {
            "title": "File Upload Date",
            "field": "CreatedOn",
            "show": true,
            "width": 40,
            filter: "date",
            format: "{0:d}",
            convert: "MM/DD/YYYY hh:mm:ss A"
        },
        {
            "title": "Created By",
            "field": "CreatedByName",
            "show": true,
            "width": 40
        },
        {
            "title": "Updated On",
            "field": "UpdatedOn",
            "show": true,
            "width": 40,
            filter: "date",
            format: "{0:d}",
            convert: "MM/DD/YYYY hh:mm:ss A"
        },
        {
            "title": "Updated By",
            "field": "UpdatedByName",
            "show": true,
            "width": 40
        },

    ],
    displayName: 'editInfo',
    allgriddata: 'allgriddata',
    navigateItem: 'navigateItem',
    navigation: 'navigation',
    loadreportfilter: 'loadreportfilter',
    ReportJsonQueryStr: 'ReportJsonQueryStr',
    mapActionsToEffects: {
        load: {
            rules: [{
                run: {
                    valid: [{
                        type: 'grid',
                        "read": [
                            {
                                url: getEnvVariable('Admin') + `/api/CompanyFiles/{Id}/CompanyFileGrid?`,
                                "matchProps": [
                                    {
                                        name: "Id",
                                        key: "Id",
                                    },
                                ],
                                type: 'get',
                                saveAs: {
                                    key: 'data'
                                }
                            }
                        ]
                    },
                    ]
                }
            }]// 1 intital load
        },
        addOpen: {
            rules: [{
                check: [
                    {
                        condition: 'AND',
                        rules: [
                            {
                                "name": "addOpen",
                                "type": "!=",
                                "value": true,
                                "rules": []
                            }
                        ]
                    }
                ],
                run: {
                    valid: [{
                        type: 'grid',
                        "read": [
                            {
                                url: getEnvVariable('Admin') + `/api/CompanyFiles/{Id}/CompanyFileGrid?`,
                                "matchProps": [
                                    {
                                        name: "Id",
                                        key: "Id",
                                    },
                                ],
                                type: 'get',
                                saveAs: {
                                    key: 'data'
                                }
                            }
                        ]
                    },
                    ]
                }
            }]
        },
        editOpen: {
            rules: [{
                check: [
                    {
                        condition: 'AND',
                        rules: [
                            {
                                "name": "editOpen",
                                "type": "!=",
                                "value": true,
                                "rules": []
                            }
                        ]
                    }
                ],
                run: {
                    valid: [{
                        type: 'grid',
                        "read": [
                            {
                                url: getEnvVariable('Admin') + `/api/CompanyFiles/{Id}/CompanyFileGrid?`,
                                "matchProps": [
                                    {
                                        name: "Id",
                                        key: "Id",
                                    },
                                ],
                                type: 'get',
                                saveAs: {
                                    key: 'data'
                                }
                            }
                        ]
                    },
                    ]
                }
            }]
        },
        'add': {
            rules: [
                {
                    run: {
                        valid: [
                            {
                                type: 'value',
                                key: 'addOpen',
                                result: true
                            },

                        ]
                    }
                }
            ]
        },
        'display': {
            rules: [
                {
                    run: {
                        valid: [
                            {
                                type: 'value',
                                key: 'editOpen',
                                result: true
                            },
                            {
                                type: 'resultvalue',
                                name: 'editInfo',
                            },
                            {
                                type: 'resultvalue',
                                name: 'allgriddata',
                            },
                            {
                                type: 'resultvalue',
                                name: 'navigateItem',
                            },
                            {
                                type: 'resultvalue',
                                name: 'navigation',
                            },

                        ]
                    }
                }
            ]
        },
        'report': {
            rules: [
                {
                    run: {
                        valid: [
                            {
                                type: 'value',
                                key: 'reportOpen',
                                result: true
                            },
                            {
                                type: 'resultvalue',
                                name: 'loadreportfilter',
                            },
                            {
                                type: 'resultvalue',
                                name: 'ReportJsonQueryStr',
                            },

                        ]
                    }
                }
            ]
        },
    }



}

const AttachmentReport = {
    type: 'popup',
    key: 'AttachmentReport',
    name: 'AttachmentReport',

    anchor: 'right',
    open: false,
    aliases: {
        open: 'reportOpen'
    },
    sharedValues: ['open', 'loadreportfilter', 'ReportJsonQueryStr'],
    container: {
        values: {
            loadreportfilter: null,
            ReportJsonQueryStr: null
        },
        mapValues: {
            Report: [
                {
                    key: 'ReportJsonQueryStr',
                    name: 'ReportJsonQueryStr'
                },
                {
                    key: 'loadreportfilter',
                    name: 'loadreportfilter'
                },
            ],
        },
        mapActionsToEffects: {},
        layout: {
            group: [
                {
                    order: 0,
                    type: 'div',
                    className: '',
                    components: [
                        {
                            name: 'Report'
                        },
                    ]
                }
            ]

        },
        components: {
            Report: {
                "type": "form",
                "key": "Report",
                "name": "Report",
                aliases: {

                },
                sharedValues: ['ReportJsonQueryStr', 'loadreportfilter'],
                values: {
                    loadreportfilter: null,
                    ReportJsonQueryStr: null
                },
                mapActionsToEffects: {},
                layout: {
                    group: [
                        {
                            order: 0,
                            type: 'div',
                            className: '',
                            components: [{
                                name: 'ReportJsonQueryStr',
                                type: 'div',

                            },
                            {
                                name: 'loadreportfilter',
                                type: 'div',

                            }],

                        },
                    ],
                },
                "components": {
                    "ReportJsonQueryStr": {
                        "type": "gridreport",
                        "gridkey": 'AttachmentGrid',
                    },
                },
            }
        }
    }
}

const AttachmentContainer = {
    type: 'container',
    key: 'AttachmentContainer',
    values: {
        addOpen: false,
        editOpen: false,
        editInfo: null,
        allgriddata: null,
        navigateItem: null,
        navigation: null,
        loadreportfilter: null,
        ReportJsonQueryStr: null,
        reportOpen: false,
    },
    mapValues: {
        AttachmentAdd: [
            {
                key: 'addOpen',
                name: 'open'
            }
        ],
        AttachmentEdit: [
            {
                key: 'editOpen',
                name: 'open'
            },
            {
                key: 'editInfo',
                name: 'editInfo'
            },
            {
                key: 'allgriddata',
                name: 'allgriddata'
            },
            {
                key: 'navigateItem',
                name: 'navigateItem'
            },
            {
                key: 'navigation',
                name: 'navigation'
            },
        ],
        AttachmentGrid: [
            {
                key: 'editOpen',
                name: 'editOpen'
            },
            {
                key: 'addOpen',
                name: 'addOpen'
            },
            {
                key: 'reportOpen',
                name: 'reportOpen'
            },
            {
                key: 'ReportJsonQueryStr',
                name: 'ReportJsonQueryStr'
            },
            {
                key: 'loadreportfilter',
                name: 'loadreportfilter'
            },
        ],
        AttachmentReport: [
            {
                key: 'reportOpen',
                name: 'open'
            },
            {
                key: 'loadreportfilter',
                name: 'loadreportfilter'
            },
            {
                key: 'ReportJsonQueryStr',
                name: 'ReportJsonQueryStr'
            },

        ]

    },
    mapActionsToEffects: {
        'addOpen': {
            rules: [
                {
                    check: [
                        {
                            condition: 'AND',
                            rules: [
                                {
                                    "name": "addOpen",
                                    "type": "!=",
                                    "value": true,
                                    "rules": []
                                }
                            ]
                        }
                    ],
                    uncheck: true,
                    run: {
                        valid: [
                            {
                                type: 'removelayout',
                                name: 'AttachmentAdd',
                            }

                        ],
                        inValid: [
                            {
                                type: 'addlayout',
                                name: 'AttachmentAdd',
                            }
                        ]
                    }
                }
            ]
        },
        'editOpen': {
            rules: [
                {
                    check: [
                        {
                            condition: 'AND',
                            rules: [
                                {
                                    "name": "editOpen",
                                    "type": "!=",
                                    "value": true,
                                    "rules": []
                                }
                            ]
                        }
                    ],
                    uncheck: true,
                    run: {
                        valid: [
                            {
                                type: 'removelayout',
                                name: 'AttachmentEdit',
                            }

                        ],
                        inValid: [
                            {
                                type: 'addlayout',
                                name: 'AttachmentEdit',
                            }
                        ]
                    }
                }
            ]
        },
        'reportOpen': {
            rules: [
                {
                    check: [
                        {
                            condition: 'AND',
                            rules: [
                                {
                                    "name": "reportOpen",
                                    "type": "!=",
                                    "value": true,
                                    "rules": []
                                }
                            ]
                        }
                    ],
                    uncheck: true,
                    run: {
                        valid: [
                            {
                                type: 'removelayout',
                                name: 'AttachmentReport',
                            }

                        ],
                        inValid: [
                            {
                                type: 'addlayout',
                                name: 'AttachmentReport',
                            }
                        ]
                    }
                }
            ]
        },
    },
    layout: {
        group: [
            {
                order: 0,
                type: 'div',
                className: 'col-12 mb-1',
                components: [
                    {
                        name: 'AttachmentGrid'
                    },
                    // {
                    //     name: 'AttachmentAdd'
                    // },
                    // {
                    //     name: 'AttachmentEdit'
                    // },
                ]
            }
        ]

    },
    components: {
        AttachmentGrid: AttachmentGrid,
        AttachmentAdd: AttachmentAdd,
        AttachmentEdit: AttachmentEdit,
        AttachmentReport: AttachmentReport
    }
}


export default AttachmentContainer

